import script from "./BuildersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildersSection.vue?vue&type=script&setup=true&lang=js"

import "./BuildersSection.vue?vue&type=style&index=0&id=fd485748&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd485748"]])

export default __exports__